 <app-transport-means-field
  [form]="form()" 
  formControlName="transportMeans"
/>

<app-max-distance-field
  [form]="form()" 
  formControlName="maxDistanceWalking"
/>